import { Box, Card, CircularProgress, Typography } from '@mui/material'
import { STARTSurveyDisplay } from '../../../../customComponents/survey/STARTSurveyDisplay'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { type SurveySchema, SurveyType } from '../../../../../models/SurveySchema'
import { styles } from '../MidYear/MidYear.styles'
import { useProgressReportAccess } from '../../../../../hooks/use-progressReportAccess'
import { useEffect, useState } from 'react'
import { handleApiResponse } from '../../../../../utils/apiHelpers'
import { GetSurvey } from '../../../../../services/SurveyService'
import { EndOfYearSummary } from './Summary/EndOfYearSummary'

export function EndOfYear (): JSX.Element {
  const { rcnId, planId, planOrgId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const annualPlanId = planId != null ? Number(planId) : 0
  const planOrgIdNum = Number(planOrgId)
  const rcnIdNum = Number(rcnId)

  const surveyTypeFromState = location.state?.surveyType as SurveyType | undefined

  const eoyType = surveyTypeFromState ?? SurveyType.RCNEndOfYear

  const { isLoading: isLoadingAccess } = useProgressReportAccess({
    annualPlanId,
    planOrgId: planOrgIdNum,
    rcnId: rcnIdNum,
    surveyTypeFromState: eoyType,
    redirectPath: '..'
  })

  const [survey, setSurvey] = useState<SurveySchema | undefined>(undefined)
  const [loadingSurvey, setLoadingSurvey] = useState(true)

  useEffect(() => {
    const fetchSurvey = async (): Promise<void> => {
      const res = await handleApiResponse(GetSurvey(eoyType, planOrgIdNum))
      setSurvey(res ?? undefined)
      setLoadingSurvey(false)
    }

    void fetchSurvey()
  }, [eoyType, planOrgIdNum])

  if (isLoadingAccess || loadingSurvey) {
    return <div><CircularProgress /></div>
  }

  const navigateToSummary = (): void => {
    setSurvey(prev => prev != null ? { ...prev, isSubmitted: true } : undefined)
  }

  const handleExit = (): void => {
    navigate(`../Organization/${String(planOrgId)}`)
  }

  if (survey?.isSubmitted === true) {
    return <EndOfYearSummary initialSurvey={survey} />
  }

  return (
    <Card sx={styles.card} data-testid='endOfYearReportCard'>
      <Box sx={styles.content}>
        <Box sx={styles.header}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at End of Year by completing the Progress Report.
        </Typography>

        <Box sx={styles.surveyContainer}>
          <STARTSurveyDisplay
            annualPlanId={annualPlanId}
            surveyType={eoyType}
            title={eoyType === SurveyType.RCNEndOfYear ? 'RCN End of Year' : 'ISD End of Year'}
            navigateToSummary={navigateToSummary}
            planOrgId={Number(planOrgId)}
            initialSurvey={survey}
            setSurvey={setSurvey}
            onExit={handleExit}
            submitModalTitle='Submit End of Year Progress Report?'
            surveyVariables={{ planOrganizationId: planOrgIdNum, rcnId, planId, planOrgId }}
          />
        </Box>
      </Box>
    </Card>
  )
}
